import { Component, OnInit } from '@angular/core';
import { UploadImageComponent } from "../../component/image/upload-image.component";
import { AuthUser } from '../../../../globalTypes/auth.types';
import { ImageUploadPublic } from '../../../../globalTypes/image.types';
import { ButtonComponent } from "../../component/layout/element/button.component";
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { lastValueFrom, take, takeUntil } from 'rxjs';
import { listingsFeature, ListingsPageActions } from '../../store/listings.store';
import { ListingService } from '../../services/listing.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { environment } from '../../../environments/environment';
import { UploadService } from '../../services/upload.service';

@Component({
  selector: 'msh-photos',
  imports:  [UploadImageComponent, ButtonComponent],
  template: `
      @if(listing && listing.id && listing.locationId){
        <div class=" text-center">Listing images</div>
        <msh-upload-image
          class=" m-auto block"
          [maxFiles]="10"
          [locationId]="listing.locationId"
          [type]="'listing'"
          [id]="listing.id"
          [existingImages]="existingImages"
          (onImageLoading)="onImagesLoading($event)"
          (onImageObjectsUpdated)="onImageObjectsUpdated($event)"
          
        ></msh-upload-image>
      }
      <div class="grow"></div>
      <msh-button class="mb-14" (onClick)="onSubmitClick($event)" [isLoading]="isLoading" [cta]="cta"></msh-button>
  `,
  styles: `:host { display: flex; flex-direction: column; flex-grow: 1; height: 100%;}`
})
export class PhotosComponent extends Base<PhotosComponent> implements OnInit {
  listing: ListingPublic | Partial<ListingPublic> | null = null;
  authUser!: AuthUser;
  existingImages: { image: ImageUploadPublic; sortOrder: number }[] = [];
  removeImageIds: string[] = [];
  cta = 'Update';
  isLoading = false;

  constructor(
    private router: Router,
    private store: Store,
    private snackbar: MatSnackBar,
    private listingService: ListingService,
    private uploadService: UploadService,
  ){
    super();
    // this.existingImages = [];
    this.store.select(listingsFeature.selectListing).pipe(takeUntil(this.$destroy)).subscribe(listing=>{
      if(!listing) return; 
      this.listing = JSON.parse(JSON.stringify(listing));
      this.existingImages = this.listing?.listingImages_on_listing || []
      if(!this.listing || !this.listing?.id || this.listing.id === 'new') {
        this.cta = 'Next';
      }
    })
  }
  async ngOnInit(): Promise<void> {
    
  }


  async onImageObjectsUpdated(imageObjects: {image: ImageUploadPublic; sortOrder: number}[]){
    const currentIds = imageObjects.map(img => img.image.id)
    if(this.listing) {
      if(this.listing.listingImages_on_listing && this.listing.listingImages_on_listing.length > 0){
        this.listing.listingImages_on_listing.forEach(imageRef => {
          if(!currentIds.includes(imageRef.image.id)) {
            this.removeImageIds.push(imageRef.image.id); // imageObjectIds
          }
        })
      }
      this.listing.listingImages_on_listing = imageObjects;
    }
  };

  onImagesLoading(fileNames: string[]){
    console.log({fileNames})
    this.isLoading = fileNames.length > 0
  }

  async onSubmitClick(ev: Event){
    if(!this.listing) throw new Error('Listing not found');
    this.isLoading = true; 
    if(!this.listing.listingImages_on_listing || this.listing.listingImages_on_listing.length === 0){
      // [ ] - TEST THIS add placeholder image to this listing
      console.log("NO IMAGES", this.listing)
      this.listing.listingImages_on_listing = [{sortOrder: 0, image: {id: environment.listingPlaceHolderImageId, statusId: "active", url: "ListingPlaceHolder.png"}}]
    }
    if(this.removeImageIds){
      await this.uploadService.deleteUploadedImages(this.removeImageIds);
    }
    if(this.listing?.id === 'new'){
      this.store.dispatch(ListingsPageActions.progressListing({listing: this.listing as Partial<ListingPublic>}))
      this.router.navigate(['manage-listing','details', this.listing.id])
    } else {
      this.isLoading = true;
      await this.listingService.saveListing(this.listing);
      this.snackbar.open("Listing photo settings have been saved", "close", {duration: 8000})
      this.isLoading = false;
    }
  }
}
